import AiIcon from '@product-framework/components/ArtificalIntelligence/AiIcon';
import { IconLibrary } from '@product-framework/index';

const getStepperConfig = ({
  userAccess,
  hasAvailabilityFeature = false,
  serviceProviderId,
  locationId,
  serviceAreaId,
  serviceAreaEnabled,
  status,
}) => [
  {
    id: 'COMPANYINFO',
    label: {
      id: 'COMPANY_INFO',
      defaultMessage: 'Company Info',
    },
    href: `/serviceproviders/edit/${serviceProviderId}`,
    icon: IconLibrary.Company,
    getErrorCount: () =>
      status?.hasServiceTravelDistance === false ? 1 : null,
  },
  {
    id: 'USERS',
    label: {
      id: 'USERS',
      defaultMessage: 'Users',
    },
    href: `/serviceproviders/edit/${serviceProviderId}/users`,
    icon: IconLibrary.Users,
    statusKey: null,
  },
  {
    id: 'LOCATIONS',
    label: {
      id: 'LOCATIONS',
      defaultMessage: 'Locations',
    },
    href: `/serviceproviders/edit/${serviceProviderId}/locations`,
    icon: IconLibrary.Locations,
    getErrorCount: () => {
      return Array.isArray(status?.hasInvalidLocationAddress) &&
        status?.hasInvalidLocationAddress.length > 0
        ? status?.hasInvalidLocationAddress.length
        : null;
    },
    parent: [
      {
        id: 'PARENT_COMPANYINFO',
        element: 'COMPANYINFO',
        label: {
          id: 'SERVICE_PROVIDER_PROFILE',
          defaultMessage: 'Service Provider Profile',
        },
      },
      {
        id: 'PARENT_LOCATIONS',
        element: 'LOCATIONS',
      },
    ],
    children: [
      {
        id: 'LOCATION_DETAIL',
        label: {
          id: 'LOCATION_DETAILS',
          defaultMessage: 'Location Details',
        },
        href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}`,
        icon: IconLibrary.ServiceProviderSingleLocation,
      },
      ...(serviceAreaEnabled
        ? [
            {
              id: 'LOCATION_SERVICEAREAS',
              label: {
                id: 'SERVICE_AREAS',
                defaultMessage: 'Service Areas',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/serviceareas`,
              icon: IconLibrary.ServiceArea,
              statusKey: null,
              parent: [
                {
                  element: 'LOCATION_DETAIL',
                },
                {
                  element: 'LOCATION_SERVICEAREAS',
                },
              ],
              children: [
                {
                  id: 'LOCATION_SERVICEAREAS_DETAIL',
                  label: {
                    id: 'SERVICEAREA_DETAILS',
                    defaultMessage: 'ServiceArea Details',
                  },
                  href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/serviceareas/${serviceAreaId}`,
                  icon: IconLibrary.ServiceProviderSingleLocation,
                },
                {
                  id: 'LOCATION_SERVICEAREAS_MAP',
                  label: {
                    id: 'SERVICE_AREA_MAP',
                    defaultMessage: 'Service Area Map',
                  },
                  href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/skills`,
                  icon: IconLibrary.ServiceArea,
                },
                {
                  id: 'LOCATION_SERVICEAREAS_SETTINGS',
                  label: {
                    id: 'SERVICE_AREA_SETTINGS',
                    defaultMessage: 'Service Area Settings',
                  },
                  href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/skills`,
                  icon: IconLibrary.SystemSetting,
                },
              ],
            },
          ]
        : []),
      {
        id: 'LOCATION_SKILLS',
        label: {
          id: 'LOCATION_SKILLS',
          defaultMessage: 'Location Skills',
        },
        href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/skills`,
        icon: IconLibrary.Skills,
      },
      {
        id: 'LOCATION_SETUP',
        label: {
          id: 'SETUP',
          defaultMessage: 'Setup',
        },
        href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/setup`,
        icon: IconLibrary.Setup,
      },
      ...(userAccess.isSA() || userAccess.isAdmin()
        ? [
            {
              id: 'LOCATION_SYSTEM_SETTINGS',
              label: {
                id: 'SYSTEM_SETTINGS',
                defaultMessage: 'System Settings',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/systemsettings/claims`,
              icon: IconLibrary.SystemSetting,
            },
          ]
        : []),
      {
        id: 'LOCATION_PERFORMANCE',
        label: {
          id: 'PERFORMANCE',
          defaultMessage: 'Performance',
        },
        href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/performance`,
        icon: IconLibrary.Performance,
      },
      ...(hasAvailabilityFeature
        ? [
            {
              id: 'PARENT_LOCATION_AVAILABILITY_LIVE_CALENDAR',
              label: {
                id: 'AVAILABILITY',
                defaultMessage: 'Availability',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/live-calendar`,
              icon: IconLibrary.AvailabilitySchedular,
              parent: [
                {
                  element: 'LOCATION_DETAIL',
                },
              ],
              children: [
                {
                  id: 'LOCATION_AVAILABILITY_LIVE_CALENDAR',
                  label: {
                    id: 'LIVE_CALENDAR',
                    defaultMessage: 'Live Calendar',
                  },
                  href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/live-calendar`,
                  icon: IconLibrary.AvailabilitySchedular,
                },
                {
                  id: 'LOCATION_AVAILABILITY_DEFAULT_SCHEDULES',
                  label: {
                    id: 'DEFAULT_SCHEDULE',
                    defaultMessage: 'Default Schedule',
                  },
                  href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/default-schedules`,
                  icon: IconLibrary.DefaultSchedule,
                },
                {
                  id: 'LOCATION_AVAILABILITY_SPECIAL_SCHEDULES',
                  label: {
                    id: 'SPECIAL_SCHEDULE',
                    defaultMessage: 'Special Schedule',
                  },
                  href: `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/special-schedules`,
                  icon: IconLibrary.SpecialSchedule,
                },
              ],
            },
          ]
        : []),
    ],
  },
  {
    id: 'SKILLS',
    label: {
      id: 'SKILLS',
      defaultMessage: 'Skills',
    },
    href: `/serviceproviders/edit/${serviceProviderId}/skills`,
    icon: IconLibrary.Skills,
    getErrorCount: () => {
      return status?.hasSkills === false ? 1 : null;
    },
  },
  {
    id: 'SETUP',
    label: {
      id: 'SETUP',
      defaultMessage: 'Setup',
    },
    href: `/serviceproviders/edit/${serviceProviderId}/setup`,
    icon: IconLibrary.Setup,
    getErrorCount: () => {
      let count = 0;
      if (status?.hasNotificationEmail === false) count += 1;
      if (status?.hasInsightCallDefault === false) count += 1;
      if (status?.hasInsightSmsDefault === false) count += 1;
      return count === 0 ? null : count;
    },
  },
  ...(userAccess.isSA() || userAccess.isAdmin()
    ? [
        {
          id: 'SYSTEMSETTINGS',
          label: {
            id: 'SYSTEM_SETTINGS',
            defaultMessage: 'System Settings',
          },
          href: `/serviceproviders/edit/${serviceProviderId}/systemsettings/claims`,
          icon: IconLibrary.SystemSetting,
          getErrorCount: () => {
            let count = 0;
            if (status?.hasDispatchMethod === false) {
              count += 1;
            }
            if (status?.hasRateCard === false) {
              count += 1;
            }
            if (status?.hasResponsiveIntegration === false) {
              count += 1;
            }
            return count > 0 ? count : null;
          },
          parent: [
            {
              id: 'PARENT_COMPANYINFO',
              element: 'COMPANYINFO',
              label: {
                id: 'SERVICE_PROVIDER_PROFILE',
                defaultMessage: 'Service Provider Profile',
              },
            },
          ],
          children: [
            {
              id: 'SYSTEM_SETTINGS_CLAIMS',
              label: {
                id: 'CLAIMS',
                defaultMessage: 'Claims',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/systemsettings/claims`,
              icon: IconLibrary.Claim,
            },
            {
              id: 'SYSTEM_SETTINGS_DISPATCH',
              label: {
                id: 'DISPATCH',
                defaultMessage: 'Dispatch',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/systemsettings/dispatch`,
              icon: IconLibrary.Dispatch,
            },
            {
              id: 'SYSTEM_SETTINGS_INSIGHT',
              label: {
                id: 'INSIGHT',
                defaultMessage: 'Insight',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/systemsettings/insight`,
              icon: AiIcon,
            },
            {
              id: 'SYSTEM_SETTINGS_API_KEY',
              label: {
                id: 'API_KEY',
                defaultMessage: 'API Key',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/systemsettings/api-key`,
              icon: IconLibrary.ApiKey,
            },
          ],
        },
      ]
    : []),
  {
    id: 'PERFORMANCE',
    label: {
      id: 'PERFORMANCE',
      defaultMessage: 'Performance',
    },
    href: `/serviceproviders/edit/${serviceProviderId}/performance`,
    icon: IconLibrary.Performance,
  },
  ...(hasAvailabilityFeature
    ? [
        {
          id: 'PARENT_AVAILABILITY_LIVE_CALENDAR',
          label: {
            id: 'AVAILABILITY',
            defaultMessage: 'Availability',
          },
          href: `/serviceproviders/edit/${serviceProviderId}/availability/live-calendar`,
          icon: IconLibrary.AvailabilitySchedular,
          parent: [
            {
              id: 'PARENT_COMPANYINFO',
              element: 'COMPANYINFO',
              label: {
                id: 'SERVICE_PROVIDER_PROFILE',
                defaultMessage: 'Service Provider Profile',
              },
            },
          ],
          children: [
            {
              id: 'AVAILABILITY_LIVE_CALENDAR',
              label: {
                id: 'LIVE_CALENDAR',
                defaultMessage: 'Live Calendar',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/availability/live-calendar`,
              icon: IconLibrary.AvailabilitySchedular,
            },
            {
              id: 'AVAILABILITY_DEFAULT_SCHEDULES',
              label: {
                id: 'DEFAULT_SCHEDULE',
                defaultMessage: 'Default Schedule',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/availability/default-schedules`,
              icon: IconLibrary.DefaultSchedule,
            },
            {
              id: 'AVAILABILITY_SPECIAL_SCHEDULES',
              label: {
                id: 'SPECIAL_SCHEDULE',
                defaultMessage: 'Special Schedule',
              },
              href: `/serviceproviders/edit/${serviceProviderId}/availability/special-schedules`,
              icon: IconLibrary.SpecialSchedule,
            },
          ],
        },
      ]
    : []),
];

export default getStepperConfig;
